/**
 * You can set the following environment variables to configure this library:
 * - KEYRO_EMAIL_TOPIC_ARN
 * - KEYRO_EMAIL_TOPIC_REGION
 * - KEYRO_EMAIL_FROM
 */
const DEFAULT_TOPIC_ARN_DEV = 'arn:aws:sns:eu-west-1:691811868441:dev-send-email';
const DEFAULT_TOPIC_ARN_PROD = 'arn:aws:sns:eu-west-1:661255705479:prod-send-email';
const DEFAULT_TOPIC_REGION_DEV = 'eu-west-1';
const DEFAULT_TOPIC_REGION_PROD = 'eu-west-1';
const DEFAULT_EMAIL_FROM_DEV = 'contact@keyro.fr';
const DEFAULT_EMAIL_FROM_PROD = 'contact@keyro.fr';
const defaultTopicArn = process.env.STAGE === 'prod' ? DEFAULT_TOPIC_ARN_PROD : DEFAULT_TOPIC_ARN_DEV;
const defaultRegion = process.env.STAGE === 'prod'
    ? DEFAULT_TOPIC_REGION_PROD
    : DEFAULT_TOPIC_REGION_DEV;
const defaultEmailFrom = process.env.STAGE === 'prod'
    ? DEFAULT_EMAIL_FROM_PROD
    : DEFAULT_EMAIL_FROM_DEV;
const topicArn = process.env.KEYRO_EMAIL_TOPIC_ARN || defaultTopicArn;
const topicRegion = process.env.KEYRO_EMAIL_TOPIC_REGION || defaultRegion;
const emailFrom = process.env.KEYRO_EMAIL_FROM || defaultEmailFrom;
export default {
    topicRegion,
    topicArn,
    emailFrom
};
